import clsx from 'clsx';
import { ReactNode, useMemo } from 'react';

import { MultiTagDisplay } from '@vestico/shared';
import globalStyle from '@vestico/shared/src/layouts/utils.module.css';

import style from './ReviewContentItem.module.css';

export interface MatchedReviewContentProps {
  title?: string;
  content?: ReactNode;
}

export const ReviewContentItem = ({ title, content }: MatchedReviewContentProps) => {
  const contentItem = useMemo(() => {
    if (content === undefined || content === null) {
      return content;
    }

    if (Array.isArray(content)) {
      if (content.length === 0) {
        return undefined;
      }
      return <MultiTagDisplay tags={content} />;
    }

    if (typeof content === 'string') {
      if (content.length === 0) {
        return null;
      }
      return <MultiTagDisplay tags={[content]} />;
    }
    return content;
  }, [content]);

  if (!contentItem) {
    return null;
  }

  return (
    <div className={clsx(style.root)}>
      {title ? <div className={clsx(globalStyle.textSmall, globalStyle.textBold, globalStyle.textColorSecondary)}>{title}</div> : null}
      <div className={clsx(style.content, globalStyle.textNormal)}>{contentItem}</div>
    </div>
  );
};
